// extracted by mini-css-extract-plugin
export var active = "_g4-1";
export var circle = "_g4-0";
export var completed = "_g4-2";
export var connector = "_g4-4";
export var connectorCompleted = "_g4-7";
export var connectorSpacer = "_g4-5";
export var iconStrokeOverride = "_g4-8";
export var labelContainer = "_g4-6";
export var pending = "_g4-3";